import { ColDef , ValueFormatterParams, RowClassParams} from 'ag-grid-enterprise';
import * as GridUtils from '../utils/gridUtils'
import InputDatetimeCellEditor from '../components/grid/InputDatetimeCellEditor';

// Grid.tsxで使用（強化の加工開始時間を計算する関数）
export const calculateNewDate = (prevDate: string, procTime: number) => {
  if (!prevDate) {
    console.error("prevDate is undefined");
    return;
  }

  const timePart = prevDate.split('T')[1];

  if (!timePart) {
    console.error("timePart is undefined");
    return;
  }

  const hasSeconds = timePart.includes(':');
  const [datePart] = prevDate.split('T');
  const [year, month, day] = datePart.split('-').map(Number);
  const [hour, minute, second] = timePart.split(':').map(Number);

  let date = new Date(year, month - 1, day, hour, minute, second || 0);
  let remainingTime = procTime;

  const breaks = [
    { start: 12 * 60 * 60, end: 12 * 60 * 60 + 50 * 60 }, //  12:00 - 12:50
    { start: 14 * 60 * 60 + 50 * 60, end: 15 * 60 * 60 }, // 14:50 - 15:00
    { start: 17 * 60 * 60 + 30 * 60, end: 17 * 60 * 60 + 40 * 60 }, // 17:30 - 17:40
    { start: 19 * 60 * 60 + 40 * 60, end: 19 * 60 * 60 + 50 * 60 }, // 19:40 - 19:50
    { start: 0 * 60 * 60 + 0 * 60, end: 0 * 60 * 60 + 10 * 60 }, // 0:00 - 00:10
    { start: 2 * 60 * 60 + 10 * 60, end: 3 * 60 * 60 }, // 2:10 - 03:00
  ];

  while (remainingTime > 0) {
    const currentTimeInSeconds = date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();

    const isBreakTime = breaks.some((br) => currentTimeInSeconds >= br.start && currentTimeInSeconds < br.end);

    if (isBreakTime) {
      const nextBreakEnd = breaks.find((br) => currentTimeInSeconds >= br.start && currentTimeInSeconds < br.end);
      if (nextBreakEnd) {
        const secondsToAdd = nextBreakEnd.end - currentTimeInSeconds;
        date = new Date(date.getTime() + secondsToAdd * 1000);
      }
    } else {
      const nextBreakStart = breaks.find((br) => currentTimeInSeconds < br.start);
      const secondsToNextBreak = nextBreakStart ? nextBreakStart.start - currentTimeInSeconds : Infinity;

      const secondsToAdd = Math.min(secondsToNextBreak, remainingTime);
      date = new Date(date.getTime() + secondsToAdd * 1000);
      remainingTime -= secondsToAdd;
    }
  }

  const newDatePart = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  const newTimePart = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}${hasSeconds ? `:${String(date.getSeconds()).padStart(2, '0')}` : ''}`;

  return `${newDatePart}T${newTimePart}`;
};

// Grid.tsxで使用
export const numericComparatorWithNullsLast = (valueA: any, valueB: any, nodeA: any, nodeB: any) => {
  valueA = nodeA?.data?.proc_order; // Ag-Gridが内部的に何らかの前処理や型変換を行っている可能性があり、うまくいかないので列名をハードコーデする
  valueB = nodeB?.data?.proc_order;

  if (valueA === null || valueA === undefined || valueA === "") {
    if (valueB === null || valueB === undefined || valueB === "") {
      return 0;
    }
    return 1;
  }
  if (valueB === null || valueB === undefined || valueB === "") {
    return -1;
  }

  return Number(valueA) - Number(valueB);
};

// Grid.tsxで使用 checkboxソート用
export const checkboxComparator = (valueA:any, valueB:any, nodeA:any, nodeB:any, isDescending:any) => {

  if (nodeA.isSelected() === true && nodeB.isSelected() === true) {
    return 0;
  }
  if (nodeA.isSelected() === false && nodeB.isSelected() === false) {
    return 0;
  }
  if (nodeA.isSelected() === true) {
    return 1;
  }
  return -1;
}

// Grit.tsxで使用
export const highlightIfOneWithColor = (backgroundColor: string, textColor: string) => (params: any) => {
  if (params.value > 0) {
    return { backgroundColor, color: textColor };
  }
  return null;
};

// Grid.tsxで使用
export const formatDateWithWeekday = (params: any) => {
  const date = params.value; // yyyy-mm-dd 形式を想定
  if (date) {
    const [year, month, day] = date.split('-');
    const weekDays = ["日", "月", "火", "水", "木", "金", "土"];
    const dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    const weekDay = weekDays[dateObj.getDay()];
    return `${month}-${day}(${weekDay})`; // mm-dd(曜日) 形式に変換
  }
  return ""; // 値が存在しない場合は空文字列を返す
};

// Grit.tsxで使用
export const calculateScheduledDateEnd = (scheduledDate: string, procTime: number) => {
  return calculateNewDate(scheduledDate, procTime);
};

export const dateComparator = (filterLocalDateAtMidnight: Date, cellValue: any): number => {
  const dateAsString = cellValue;
  if (dateAsString == null) return -1;
  const dateParts = dateAsString.split('-');
  const cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));

  if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
    return 0;
  }

  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  }

  if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
};

  // 日時のセルフォーマッター
export const datetimeCellValueFormatter = (params: ValueFormatterParams) => {
    if (params.value) {
      try {
        const date = new Date(params.value)
        const year = (date.getFullYear() + '').slice(-2);
        const month = ("0" + (date.getMonth() + 1)).slice(-2); // 月は0から始まるため、1を加える
        const day = ("0" + date.getDate()).slice(-2);
        const hours = ("0" + date.getHours()).slice(-2);
        const minutes = ("0" + date.getMinutes()).slice(-2);
        const seconds = ("0" + date.getSeconds()).slice(-2);
        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        console.log(e);
      }
    }
    return "";
  }


// 日本語化
export const gridLocaleText = {
  contains: '含む(contains)',
  notContains: '含まない(not contains)',
  startsWith: 'で始まる(starts with)',
  endsWith: 'で終わる(ends with)',
  equals: '等しい(equals)',
  lessThan: 'より小さい(less than)',
  greaterThan: 'より大きい(greater than)',
  lessThanOrEqual: '以下(less than or equals)',
  greaterThanOrEqual: '以上(greater than or equals)',
  inRange: 'の範囲内(in range)',
  blank: '空白(blank)',
  notEqual: '等しくない(not equal)',
  notBlank: '空白でない(not blank)',
  // ... その他のテキストもここで設定可能
};

// Grid.tsxで使用
export const procStatusFormatter = (params: ValueFormatterParams) => {
  switch(params.data.proc_status) {
    case 0:
      if (params.data.urgency_level > 0) {
        return "緊急";
      }
      return "未作";
    case 1:
      return "作中";
    case 2:
      return "中断";
    case 3:
      return "作中";
    case 4:
      return "完了";
    default:
      return "未定義";
  }
}

export const procStatusCellSyle = (params: ValueFormatterParams) => {
  switch(params.data.proc_status) {
    case 0:
      if (params.data.urgency_level > 0) {
        // 緊急（未作）
        return { backgroundColor: '#FF3366', color: 'white' };
      }
      // 未作
      return null;
    case 1:
      // 作中
      return  { backgroundColor: '#49BEAA', color: 'white' };
    case 2:
      // 中断
      return { backgroundColor: '#CACBCA', color: 'black' };;
    case 3:
      // 再開
      return { backgroundColor: '#49BEAA', color: 'white' };
    case 4:
      // 完了
      return null;
    default:
      return null;
  }
}

export const procRowClassRules = {
  'procgrid-row-urgency': (params: RowClassParams) => {
    switch(params.data.proc_status) {
      case 0:
        if (params.data.urgency_level > 0) {
          // 緊急（未作）
          return true;
        }
        return false;
      default:
        return false;
    }
  },
}


export const defaultColDef = {
  resizable: true,
  // enableRowGroup: true,
  floatingFilter: true,
  // enableCellTextSelection: true
};

// APIで取得したカラム定義は関数オブジェクトを含めていないので置き換え処理を行う
export const convertColumnsDef = (def:any[]) : ColDef[] => {
  console.log("convertColumnsDef")
  const aggridDef = def.map(d => {
    let convertDef = {...d}

    // comparatorの置き換え
    if (d.comparator !== undefined) {
      switch (d.comparator) {
        case "numericComparatorWithNullsLast":
          convertDef.comparator = GridUtils.numericComparatorWithNullsLast;
          break;
        case "dateComparator":
          convertDef.comparator = GridUtils.dateComparator;
          break;
        case "checkboxComparator":
          convertDef.comparator = GridUtils.checkboxComparator;
          break;
      }
    }

    if (d.filterParams !== undefined) {
      convertDef.filterParams = {...d.filterParams}
    }

    // filterParams.comparatorの置き換え
    if (d.filterParams !== undefined && d.filterParams.comparator) {
      switch (d.filterParams.comparator) {
        case "numericComparatorWithNullsLast":
          convertDef.filterParams.comparator = GridUtils.numericComparatorWithNullsLast;
          break;
        case "dateComparator":
          convertDef.filterParams.comparator = GridUtils.dateComparator;
          break;
        case "checkboxComparator":
          convertDef.filterParams.comparator = GridUtils.checkboxComparator;
          break;
      }
    }

    // formattterの置き換え
    if (d.valueFormatter !== undefined) {
      switch (d.valueFormatter) {
        case "procStatusFormatter":
          convertDef.valueFormatter = GridUtils.procStatusFormatter;
          break;
        case "formatDateWithWeekday":
          convertDef.valueFormatter = GridUtils.formatDateWithWeekday;
          break;
        case "datetimeCellValueFormatter":
          convertDef.valueFormatter = GridUtils.datetimeCellValueFormatter;
          break;
      }
    }

    // cellStyleの置き換え
    if (d.cellStyle !== undefined) {
      switch (d.cellStyle) {
        case "procStatusCellSyle":
          convertDef.cellStyle = GridUtils.procStatusCellSyle;
          break;
          
        case "highlightIfOneWithColor":
          if (d.cellStyleParams.length === 2) {
            convertDef.cellStyle = GridUtils.highlightIfOneWithColor(d.cellStyleParams[0], d.cellStyleParams[1]);
          } else {
            convertDef.cellStyle = GridUtils.highlightIfOneWithColor("white", "black");
          }
          break;
          
      }
    }

    // filterParam.comparatorの置き換え
    if (d.filterParams !== undefined) {
      if (d.filterParams.comparator !== undefined) {
        switch (d.filterParams.comparator) {
          case "dateComparator":
            convertDef.filterParams.comparator = GridUtils.dateComparator;
            break;
        }
      }
    }

    // cellEditorの置き換え
    if (d.cellEditor !== undefined) {
      switch (d.cellEditor) {
        case "InputDatetimeCellEditor":
          convertDef.cellEditor = InputDatetimeCellEditor;
          break;
      }
    }

    return convertDef;
  })
  return aggridDef;
};
